import { getActivity, getCompany, getRate, getServiceType } from 'Api/dashboardApi'
import { DashboardState, ServiceTypeList } from 'Types/_Store/CompanyAccount'
import cloneDeep from 'lodash/cloneDeep'


export const state: DashboardState = {
  requesting: {
    acitivity: false,
    rate: false,
    company: false
  },

  activity: {
    approvedCount: 0,
    disregardedCount: 0,
    expiratedCount: 0,
    ongoingCount: 0,
    paidCount: 0,
    receivedCount: 0,
    refusedCount: 0,
    reprovedCount: 0,
  },

  serviceTypeList: [],

  company: {
    fancyName: '',
    logoSmallPath: null,
    slug: '',
    isChecked: null,
    about: ''
  },

  rate: {
    rating: 0,
    reputation: 0
  },

  filters: {
    serviceTypeId: null,
    endDate: null,
    startDate: null,
  }

}
export const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_activity(state, activity) {
    state.activity = activity
  },

  set_service_type_list(state, serviceTypeList) {
    state.serviceTypeList = serviceTypeList
  },

  set_filters(state, filters) {
    state.filters = filters
  },

  set_company(state, company) {
    state.company = company
  },

  set_rate(state, rate) {
    state.rate = rate
  },
}

export const actions = {

  async getDashServiceTypeList({ commit }) {
    commit('request_start', 'serviceType')

    try {
      const { data } = await getServiceType()
      commit('set_service_type_list', data)

      commit('request_success', 'serviceType')


      return data
    } catch (err) {
      commit('request_failure', 'serviceType')

      throw err
    }
  },

  async getDashActivity({ commit, state }) {
    commit('request_start', 'acitivity')

    const filters = state.filters

    try {
      const { data } = await getActivity(filters)
      commit('set_activity', data)

      commit('request_success', 'acitivity')


      return data
    } catch (err) {
      commit('request_failure', 'acitivity')

      throw err
    }
  },

  async getDashCompany({ commit }) {
    commit('request_start', 'company')

    try {
      const { data } = await getCompany()
      commit('set_company', data)

      commit('request_success', 'company')


      return data
    } catch (err) {
      commit('request_failure', 'company')

      throw err
    }
  },

  async getDashRate({ commit }) {
    commit('request_start', 'rate')

    try {
      const { data } = await getRate()
      commit('set_rate', data)

      commit('request_success', 'rate')


      return data
    } catch (err) {
      commit('request_failure', 'rate')

      throw err
    }
  },

  updateFilters({ commit, state, dispatch}, filter) {
    commit('set_filters', Object.assign(
      cloneDeep(state.filters),
      filter
    ))
    dispatch('getDashActivity');
  },

}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}